<template>
  <div class="page-view">
    <!-- 面包屑 -->
    <a-breadcrumb class="page-breadcrumb">
      <a-breadcrumb-item>系统设置</a-breadcrumb-item>
      <a-breadcrumb-item>支付安全</a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 页面内容 -->
    <div class="page-content">
      <!-- 支付密码开关 -->
      <div class="setting-item">
        <div class="left-content">
          <div class="item-title">支付密码开关</div>
          <div class="item-desc">付薪时是否需要输入支付密码</div>
        </div>
        <div style="flex: 1;"></div>
        <div class="right-content">
          <a-switch
            :checked="isPayAuth"
            checked-children="开"
            un-checked-children="关"
            @click="touchOpenPassword"
          />
        </div>
      </div>
      <!-- 支付密码 -->
      <div class="setting-item">
        <div class="left-content">
          <div class="item-title">支付密码</div>
          <div class="item-desc" v-if="!isPayPassword">您尚未设置支付密码</div>
          <div class="item-desc" v-if="isPayPassword">您已设置支付密码</div>
        </div>
        <div style="flex: 1;"></div>
        <div class="right-content">
          <a @click="touchSetting" v-if="!isPayPassword">设置</a>
          <a @click="touchModify" v-if="isPayPassword">修改密码</a>
          <a @click="touchRetrieve" v-if="isPayPassword">找回密码</a>
        </div>
      </div>
    </div>
    <!-- 手机绑定 -->
    <PhoneSettingModal ref="PhoneSettingModal" @success="phoneSettingSuccess"></PhoneSettingModal>
    <!-- 找回密码 -->
    <PasswordRetrieveModal ref="PasswordRetrieveModal"></PasswordRetrieveModal>
    <!-- 设置密码 -->
    <PasswordSettingModal ref="PasswordSettingModal" @success="passwordSettingSuccess"></PasswordSettingModal>
    <!-- 修改密码 -->
    <PasswordModifyModal ref="PasswordModifyModal"></PasswordModifyModal>
    <!-- 停用支付密码 -->
    <PasswordStopModal ref="PasswordStopModal" @success="passwordStopSuccess"></PasswordStopModal>
  </div>
</template>

<script>
import PhoneSettingModal from './components-payment-security/phone-setting-modal'
import PasswordRetrieveModal from './components-payment-security/password-retrieve-modal'
import PasswordSettingModal from './components-payment-security/password-setting-modal'
import PasswordModifyModal from './components-payment-security/password-modify-modal'
import PasswordStopModal from './components-payment-security/password-stop-modal'
import { getMobileUserinfo, openMobilePassword } from '@/api/hp-request'
export default {
  components: {
    PhoneSettingModal,
    PasswordRetrieveModal,
    PasswordSettingModal,
    PasswordModifyModal,
    PasswordStopModal
  },
  data () {
    return {
      // 手机号
      phone: '',
      // 是否设置了支付密码
      isPayPassword: true,
      // 是否开启支付密码
      isPayAuth: false
    }
  },
  mounted () {
    // 获取个人信息
    this.getMobileUserinfo()
  },
  methods: {
    // 手机绑定成功
    phoneSettingSuccess (phone) {
      this.phone = phone
    },
    // 支付密码设置成功
    passwordSettingSuccess () {
      this.isPayPassword = true
    },
    // 停用支付密码
    passwordStopSuccess () {
      this.isPayAuth = false
    },
    // 切换支付开关
    touchOpenPassword () {
      // 开启
      if (!this.isPayPassword) {
        // 检查是否设置了支付密码
        this.$info({
          title: '请先设置支付密码',
          content: '设置支付密码后才可启用支付密码',
          okText: '知道了'
        })
        return
      }
      // 是否开启了支付密码
      if (this.isPayAuth) {
        // 关闭
        this.$refs['PasswordStopModal'].showModal()
      } else {
        // 开启
        openMobilePassword().then(res => {
          const { code, message } = res
          if (code === 0) {
            this.isPayAuth = true
            this.$message.success('开启成功')
          } else {
            this.$message.error(message)
          }
        }).catch(() => {
          this.$message.error('开启失败')
        })
      }
    },
    // 设置密码
    touchSetting () {
      // 检查是否绑定了手机号
      if (!this.phone) {
        const that = this
        this.$confirm({
          title: '请先绑定手机号',
          content: '找回支付密码时需要进行手机号验证',
          cancelText: '暂不绑定',
          okText: '立即绑定',
          onOk: () => {
            // 弹出绑定手机窗口
            that.$refs['PhoneSettingModal'].showModal()
          }
        })
        return
      }
      // 弹出设置密码窗口
      this.$refs['PasswordSettingModal'].showModal()
    },
    // 修改密码
    touchModify () {
      this.$refs['PasswordModifyModal'].showModal()
    },
    // 找回密码
    touchRetrieve () {
      this.$refs['PasswordRetrieveModal'].showModal(this.phone)
    },
    // 显示弹窗
    showModal () {
      // 获取类型
      const type = this.$route.query.type
      // 判断类型
      if (type === 'forget') {
        // 设置了支付密码，但是忘记密码了
        if (this.isPayPassword) {
          // 找回密码
          this.touchRetrieve()
        }
      }
    },
    // 获取个人信息
    getMobileUserinfo () {
      getMobileUserinfo().then(res => {
        const { code, data } = res
        if (code === 0) {
          // 获取信息
          this.phone = data.account['1']
          this.isPayAuth = !!data.wx_pay_auth
          this.isPayPassword = !!data.wx_pay_password
          // 判断显示窗口
          this.showModal()
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.page-view {
  padding: 24px 32px;
}
.setting-item:first-child {
  margin-top: 20px;
}
.setting-item {
  height: 92px;
  border-bottom: 1px solid #E6E6E6;
  display: flex;
}
.left-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.right-content {
  display: flex;
  align-items: center;
}
.right-content a {
  margin-left: 8px;
}
.setting-item .item-title {
  font-weight: 650;
  color: rgba(0, 0, 0, 0.85);
  line-height: 22px;
}
.setting-item .item-desc {
  color: rgba(0, 0, 0, 0.45);
  line-height: 22px;
}
</style>